import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import type { ShipmentPriority } from '../types';

const priorityStyles: Record<ShipmentPriority, string> = {
  normal: 'bg-muted text-muted-foreground hover:bg-muted',
  high: 'bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-900 dark:text-amber-200',
  urgent:
    'bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-900 dark:text-red-200'
};

const priorityTranslationKeys: Record<ShipmentPriority, string> = {
  normal: 'priorityNormal',
  high: 'priorityHigh',
  urgent: 'priorityUrgent'
};

interface ShippingPriorityTagProps {
  priority: ShipmentPriority;
}

export function ShippingPriorityTag({ priority }: ShippingPriorityTagProps) {
  const t = useTranslations('shipping');

  return (
    <Badge variant='secondary' className={cn(priorityStyles[priority])}>
      {t(priorityTranslationKeys[priority])}
    </Badge>
  );
}
